import { styled } from '../../../../modules';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
`;

export const LogoSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px 24px;
    border-bottom: 1px solid #e5e5e5;
    flex-shrink: 0;
`;

export const LogoImage = styled.img`
    max-width: 140px;
    max-height: 40px;
    object-fit: contain;
`;

export const Content = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px;
    gap: 24px;
    width: 100%;
`;

export const IconWrapper = styled.div<{ $color: string }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 96px;
    height: 96px;
    border-radius: 50%;
    border: 4px solid ${({ $color }) => $color};
    color: ${({ $color }) => $color};
`;

export const Title = styled.h1<{ $color: string }>`
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    text-align: center;
    color: ${({ $color }) => $color};
    max-width: 320px;
`;

export const Subtitle = styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    text-align: center;
    color: #666666;
    max-width: 320px;
`;

export const Footer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 16px 0 24px;
`;
